import type { ELanguage } from '@if/core/types'
import type { ECommunicationType } from './InvitationSchema'

export enum EInvitationDeliveryStatus {
  Pending = 'pending',
  Sent = 'sent',
  Delivered = 'delivered',
  Failed = 'failed',
}

/**
 * One channel an invitation went out on. An email-only or SMS-only send has a single entry, a "both"
 * send has two, each with its own recipient and its own delivery status.
 */
export interface InvitationHistoryChannelDto {
  communicationType: ECommunicationType
  recipient: string | null
  /** When this channel went out. Null on rows written before the per-channel stamps existed. */
  sentAt: string | null
  deliveryStatus: EInvitationDeliveryStatus | null
}

export interface InvitationHistoryEntryDto {
  id: string
  communicationType: ECommunicationType | null
  firstName: string | null
  lastName: string | null
  languageId: ELanguage
  /** The optional financing amount set on the invitation; null when none was provided. */
  amount: number | null
  sentAt: string
  sentByUserId: string | null
  sentByUserFullname: string | null
  resentFromInvitationId: string | null
  channels: InvitationHistoryChannelDto[]
}

/** The merchant comes from the caller's token, except for a banner reading one of its subsidiaries. */
export interface InvitationHistoryFilterDto {
  /** Subsidiary a banner user reads the history of; null for standard users (token merchant). */
  merchantId?: string | null
  /** One term matched against the recipient's name, email or phone. */
  search?: string | null
  firstName?: string | null
  lastName?: string | null
  email?: string | null
  mobilePhoneNumber?: string | null
  communicationType?: ECommunicationType | null
  deliveryStatus?: EInvitationDeliveryStatus | null
  sentByUserId?: string | null
  sentFrom?: string | null
  sentTo?: string | null
  offset?: number
  limit?: number
}
